import "./Assets/FontAwesomePro/css/all.css"
import Pages from "./Pages";
import "./App.css";
import "./iconsax.css";
if(window.location.hostname==="localhost"){
  localStorage.setItem(
      "apiUrl",
      "http://localhost/Git/Delsa/Frm"
      // "http://localhost/Saden/Frm"
  );
}else {
  localStorage.setItem(
      "apiUrl",
      "/Frm"
  );
}


function App() {
  return <Pages />;
}

export default App;